export default "__VITE_ASSET__71444ece__"